import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
	AlertDialogTrigger,
} from '@journ/ui/alert-dialog'
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@journ/ui/dropdown-menu'
import { Icons } from '@journ/ui/icons'
import { Sheet, SheetContent, SheetHeader } from '@journ/ui/sheet'
import { useIntlayer } from 'react-intlayer'
import { useCustomerEditSheet } from '../hooks/use-customer-edit-sheet'
import { CustomerEnrichmentSection } from './customer-enrichment-section'
import { CustomerForm } from './customer-form'

const CustomerEditSheet = () => {
	const content = useIntlayer('customers-page')
	const {
		customer,
		isOpen,
		close,
		isEnriching,
		hasEnrichmentData,
		canEnrich,
		handleSubmit,
		handleDelete,
		handleStartEnrichment,
		handleCancelEnrichment,
		handleClearEnrichment,
	} = useCustomerEditSheet()

	return (
		<Sheet open={isOpen} onOpenChange={close}>
			<SheetContent stack title={content.editSheet.title.value} className='flex flex-col'>
				<SheetHeader className='mb-6 flex justify-between items-center flex-row shrink-0'>
					<h2 className='text-xl'>{content.editSheet.title}</h2>
					{customer && (
						<DropdownMenu>
							<DropdownMenuTrigger asChild>
								<button type='button'>
									<Icons.MoreVertical className='size-5' />
								</button>
							</DropdownMenuTrigger>
							<DropdownMenuContent sideOffset={10} align='end'>
								{isEnriching ? (
									<DropdownMenuItem onClick={handleCancelEnrichment}>{content.actions.cancelEnrichment}</DropdownMenuItem>
								) : (
									canEnrich && (
										<DropdownMenuItem onClick={handleStartEnrichment}>
											{hasEnrichmentData ? content.actions.refreshEnrichment : content.actions.enrich}
										</DropdownMenuItem>
									)
								)}
								{hasEnrichmentData && !isEnriching && (
									<DropdownMenuItem onClick={handleClearEnrichment}>{content.actions.clearEnrichment}</DropdownMenuItem>
								)}
								<AlertDialog>
									<AlertDialogTrigger asChild>
										<DropdownMenuItem className='text-destructive' onSelect={e => e.preventDefault()}>
											{content.deleteDialog.confirm}
										</DropdownMenuItem>
									</AlertDialogTrigger>
									<AlertDialogContent>
										<AlertDialogHeader>
											<AlertDialogTitle>{content.deleteDialog.title}</AlertDialogTitle>
											<AlertDialogDescription>{content.deleteDialog.description}</AlertDialogDescription>
										</AlertDialogHeader>
										<AlertDialogFooter>
											<AlertDialogCancel>{content.deleteDialog.cancel}</AlertDialogCancel>
											<AlertDialogAction onClick={handleDelete}>
												{content.deleteDialog.confirm}
											</AlertDialogAction>
										</AlertDialogFooter>
									</AlertDialogContent>
								</AlertDialog>
							</DropdownMenuContent>
						</DropdownMenu>
					)}
				</SheetHeader>
				{customer && (
					<div className='flex flex-col min-h-0 flex-1'>
						<div className='shrink-0 mb-6'>
							<CustomerEnrichmentSection customer={customer} />
						</div>
						<CustomerForm data={customer} key={customer.id} onSubmit={handleSubmit} onCancel={close} />
					</div>
				)}
			</SheetContent>
		</Sheet>
	)
}

export { CustomerEditSheet }
